/* global myModal, myCookie, analyticEventTracker */

var referral = {
    mode: false,
    form: false,
    validator: false,
    buttonClicked: false,
    isLinkCopied: false,
    init: function() {
        referral.initForm();
        referral.openClaimPopup();
        referral.claimReferralBonusForm();
        referral.validate();
    },
    initForm: function() {
        $('#generateReferralLinkBtn').on('click', function() {
            const that = $(this);

            const email = $('#advocateEmail').val();
            const residenceCountry = $('#advocateResidenceCountry').val();
            const url = _d.url.referral.generateReferreLink
                .replace('residence', residenceCountry).replace('email', email);

            that.addClass('loading');

            $.get(url, function(response) {
                if (!response.succeeded) {
                    return;
                }

                $('#send-referral-invitation').val(response.registerUrl);
                that.hide();
                $('#copyReferralLinkBtn').show();
            }).always(function() {
                that.removeClass('loading');
            });
        });

        $('#copyReferralLinkBtn').on('click', function() {
            const friendLink = $('input[name="send_referral_invitation"]').val();
            navigator.clipboard.writeText(friendLink).then(() => {
                $('.copy-link-btn-text').hide();
                $('.copied-link-btn-text').show();
            });

            if (!referral.isLinkCopied) {
                referral.isLinkCopied = true;
                analyticEventTracker.sendInstantEvent('GiveGet_Link_Copied');
            }
        });
    },
    openClaimPopup: function() {
        const urlParams = new URLSearchParams(window.location.search);
        const promoUid = urlParams.get('referral');
        const referralBcCookie = myCookie.getCookie('dch-ref');

        if (!promoUid || Boolean(referralBcCookie)) {
            return;
        }

        setTimeout(() => {
            myModal.openStaticModal('referralClaimModal', { noHeader: true, modalWindowClass: 'w-768' });
            referral.validate();
        }, 1000);
    },
    claimReferralBonusForm: function() {
        $('#claimReferralBonusForm').on('submit', function(e) {
            e.preventDefault();
        });
    },
    validate: function() {
        $('.claim-referral-bonus-btn').on('click', function(e) {
            e.preventDefault();
            const btn = $(this);
            const emailErrors = $('#referee-email-error.error');
            const hasErrors = emailErrors.length > 0 && !emailErrors.is(':hidden');

            if (btn.hasClass('loading') || hasErrors) {
                return false;
            }

            btn.addClass('loading');

            $('#claimReferralBonusForm').submit();
        });

        const claimReferralBonusValidator = $(document).find('#claimReferralBonusForm').validate({
            errorClass: 'error',
            focusInvalid: false,
            errorElement: 'div',
            rules: {
                refereeEmail: {
                    validate_email: true,
                    required: true,
                    email: false
                }
            },
            errorPlacement: function(error, el) {
                $(el).next().html(error);
            },
            highlight: function(el, ec) {
                $(el).addClass(ec);
            },
            unhighlight: function(el, ec) {
                $(el).removeClass(ec);
            },
            invalidHandler: function() {
                $('.referral-claim-error-block').hide();

                setTimeout(function() {
                    $('.claim-referral-bonus-btn').removeClass('loading');
                }, 10);
            },
            submitHandler: function(form) {
                const errorNotificationBlock = $('.referral-claim-error-block');
                errorNotificationBlock.hide();

                $.postJSON(_d.url.referral.registerFriend, $(form).serialize(), function(response) {
                    if (!response.errors.length && !response.errors.description) {
                        const { hpBannerContent } = response;

                        const promoBanner = $('.home-promo');
                        const referralBanner = $('.home-referral-bonus-disclaimer');
                        referralBanner.find('p').html(hpBannerContent);

                        referralBanner.removeClass('hide');
                        promoBanner.hide();
                        $('.home-caption').addClass('hide');

                        myModal.close('referralClaimModal');
                        referral.removePromoFromUrl();
                    } else {
                        const [{ title, description }] = response.errors;

                        claimReferralBonusValidator.showErrors({ refereeEmail: null });

                        $('#referralRegisterBtn').removeClass('loading').blur();
                        errorNotificationBlock.find('.error-title').text(title);
                        errorNotificationBlock.find('.error-description').text(description);
                        errorNotificationBlock.show();
                    }
                });
            }
        });
    },
    removePromoFromUrl: function() {
        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.delete('referral');
        setTimeout(() => window.history.replaceState({}, document.title, currentUrl.toString()), 1000);
    }
};
